import { isRIO4RentalProductId } from '../../../config/rio4rentalProduct';
import type { ProductInfo } from '../redux/types';
import { ProductCellBookableContainer } from './ProductCellBookable';
import { ProductCellBookedContainer } from './ProductCellBooked';
import { ProductCellBookedContractContainer } from './ProductCellBookedContract';
import { ProductCellExternallyManaged } from './ProductCellExternallyManaged';
import { ProductCellNotBookableContainer } from './ProductCellNotBookable';
import { ProductCellPendingContainer } from './ProductCellPending';

interface Props {
    product: ProductInfo;
    assetId: string;
    assetName: string;
    productLabel: string;
}

export const ProductCell = (props: Props) => {
    const { product, assetId, assetName, productLabel } = props;

    if (assetId === '146864ba-d49d-4229-8603-3fad9fecdd0d') {
        console.debug(product);
    }

    if (isRIO4RentalProductId(product.productId)) {
        return <ProductCellExternallyManaged product={product} />;
    }
    if (product.booked && !product.isPending && product.hasContractPeriod) {
        return <ProductCellBookedContractContainer product={product} assetId={assetId} productLabel={productLabel} />;
    }
    if (product.booked && !product.isPending && !product.hasContractPeriod) {
        return (
            <ProductCellBookedContainer
                product={product}
                assetId={assetId}
                assetName={assetName}
                productLabel={productLabel}
            />
        );
    }
    if (product.isPending) {
        return <ProductCellPendingContainer product={product} productLabel={productLabel} />;
    }
    if (product.bookable) {
        return (
            <ProductCellBookableContainer
                product={product}
                assetId={assetId}
                assetName={assetName}
                productLabel={productLabel}
            />
        );
    }

    return <ProductCellNotBookableContainer product={product} />;
};
